package com.karawek.core.ui.theme

import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.sp

// Web (Wasm/JS) — system font, HIG-aligned values
// The design system loads SF Pro via @font-face in the browser;
// Compose for Web will use the system font stack.
private val baseFontFamily = FontFamily.Default

internal actual fun createCoreTypographyScheme(): CoreTypographyScheme = CoreTypographyScheme(
    display = TextStyle(
        fontFamily = baseFontFamily,
        fontSize = 34.sp,
        fontWeight = FontWeight.Bold,
        lineHeight = 41.sp,
    ),
    headline = TextStyle(
        fontFamily = baseFontFamily,
        fontSize = 17.sp,
        fontWeight = FontWeight.SemiBold,
        lineHeight = 22.sp,
    ),
    title = TextStyle(
        fontFamily = baseFontFamily,
        fontSize = 28.sp,
        fontWeight = FontWeight.Bold,
        lineHeight = 34.sp,
    ),
    title2 = TextStyle(
        fontFamily = baseFontFamily,
        fontSize = 22.sp,
        fontWeight = FontWeight.Bold,
        lineHeight = 28.sp,
    ),
    title3 = TextStyle(
        fontFamily = baseFontFamily,
        fontSize = 20.sp,
        fontWeight = FontWeight.SemiBold,
        lineHeight = 25.sp,
    ),
    body = TextStyle(
        fontFamily = baseFontFamily,
        fontSize = 17.sp,
        fontWeight = FontWeight.Normal,
        lineHeight = 22.sp,
    ),
    callout = TextStyle(
        fontFamily = baseFontFamily,
        fontSize = 16.sp,
        fontWeight = FontWeight.Normal,
        lineHeight = 21.sp,
    ),
    bodySecondary = TextStyle(
        fontFamily = baseFontFamily,
        fontSize = 15.sp,
        fontWeight = FontWeight.Normal,
        lineHeight = 20.sp,
    ),
    caption = TextStyle(
        fontFamily = baseFontFamily,
        fontSize = 13.sp,
        fontWeight = FontWeight.Normal,
        lineHeight = 18.sp,
    ),
    footnote = TextStyle(
        fontFamily = baseFontFamily,
        fontSize = 12.sp,
        fontWeight = FontWeight.Normal,
        lineHeight = 16.sp,
    ),
)
